import * as React from 'react';
import { questionActionsMap } from '../constants/questionActionsMap';
import { jsx as _jsx } from "react/jsx-runtime";
export var useActionsList = function useActionsList(question) {
  var actions = question.actions;
  return React.useMemo(function () {
    if (!actions) {
      return null;
    }
    return actions.reduce(function (actionsList, action, currentIndex) {
      var ActionContainer = questionActionsMap[action.type];
      if (ActionContainer) {
        actionsList.push( /*#__PURE__*/_jsx(ActionContainer, {
          question: question,
          children: action.text
        }, currentIndex));
      }
      return actionsList;
    }, []);
  }, [actions, question]);
};